module.exports = __webpack_public_path__ + "static/media/EmptySurveyImage.8daa19aa.png";